import './styles/state-message.css';

export default function LoadingState({ label = 'Cargando…', rows = 3 }) {
    return (
        <div className="state-message state-message--loading" role="status" aria-live="polite">
            <span className="visually-hidden">{label}</span>
            {Array.from({ length: rows }, (_, index) => (
                <span key={index} className="state-message__skeleton" aria-hidden="true" />
            ))}
        </div>
    );
}
